import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import './App.css';
import ChangeEmail from "./ChangeEmail";
// import CheckEmail from "./checkEmail";
import CheckEmail from "./CheckEmail";
import ResetEmailLink from "./ResetEmailLink";
import ForgotPassword from "./ForgotPassword";
//import ActionResetPassword from "./components/ActionResetPassword/ActionResetPassword";
import Action from "./auth/action";
import { ToastContainer } from "react-toastify";
function App() {
  return (
    <Router>
    <div className="App">
      <ToastContainer />
     <Routes>
          <Route path="/changeEmail" element={<ChangeEmail/>} />
          <Route path="/checkEmail" element={<CheckEmail/>} />
          <Route path="/resetEmailLink" element={<ResetEmailLink/>} />
          <Route path="/forgotPassword" element={<ForgotPassword/>} />
          <Route path="/email-handler" element={<Action/>} />
     </Routes>
    </div>
    </Router>
  );
}

export default App;
